const COGNITO_ERROR_CODE = {
    // 登録しようとしたユーザーが既に存在する
    UsernameExistsException: "UsernameExistsException",
    // ユーザーが見つからない
    UserNotFoundException: "UserNotFoundException",
    // リクエストパラメーターが間違っている（パスワードの長さが足りない場合はこれ）
    InvalidParameterException: "InvalidParameterException",
    // ユーザー認証に失敗
    NotAuthorizedException: "NotAuthorizedException",
    // パスワードのリセットが必要
    PasswordResetException: "PasswordResetException",
    // 試行回数の上限
    LimitExceededException: "LimitExceededException",
    // 検証コードが一致しない
    CodeMismatchException: "CodeMismatchException",
    // コードが期限切れ
    ExpiredCodeException: "ExpiredCodeException",
    // 検証コードの送信失敗
    CodeDeliveryFailureException: "CodeDeliveryFailureException",
};

export default {
    methods: {
        convertSignUpErrorMessage(err) {
            /**
             * 下記の種類が用意されているが、まとめて「認証に失敗しました。」とする
             * ---------------------------------------------------------------
             * General(どのタイミングでも発生し得る)
             *   InternalErrorException
             *     Cognito内部での例外。余程のことが無い限り発生しないと思われる。
             * 
             *   InvalidLambdaResponseException
             *     Cognitoで指定できるトリガーLambda関数のレスポンスが無効である。
             * 
             *   UnexpectedLambdaException
             *     Cognitoで指定できるトリガーLambda関数内部で例外が発生。
             * 
             *   ResourceNotFoundException
             *     ResourceのID等の指定を間違っている可能性がある。そもそも作ってない説もある。
             * 
             *   TooManyRequestsException
             *     文字通り、requestを飛ばしすぎによる例外。
             * 
             * SignUp関連
             *   CodeDeliveryFailureException
             *     検証コードの配信に失敗した時に起こる。
             * 
             *   InvalidEmailRoleAccessPolicyException
             *     メールアドレス周りのRole関連による例外。
             * 
             *   InvalidSmsRoleAccessPolicyException
             *     これも権限周り。検証コードを発行する権限が無い。
             * 
             *   InvalidSmsRoleTrustRelationException
             *     これも権限周り。Roleの不一致(IDPoolやサードパーティ関連)
             * 
             *   InvalidParameterException
             *     必要なユーザー属性が足りなかったりした時に発生。
             * 
             *   InvalidPasswordException
             *     Cognito側で設定したパスワード要件を満たしていない時に発生する。
             *     追記）パスワードの長さが足りない場合はInvalidParameterExceptionの方に引っかかるっぽい
             * ---------------------------------------------------------------
             */
            switch (err.code) {
                case COGNITO_ERROR_CODE.UsernameExistsException:
                    return `登録済みのメールアドレスです。`;
                case COGNITO_ERROR_CODE.CodeMismatchException:
                    return `検証コードが一致しませんでした。`
                case COGNITO_ERROR_CODE.ExpiredCodeException:
                    return `期限切れの検証コードです。`
                case COGNITO_ERROR_CODE.LimitExceededException:
                    return `試行回数の上限に達しました。時間をおいてから再度お試しください。`;
                case COGNITO_ERROR_CODE.CodeDeliveryFailureException:
                    return `検証コードの送信に失敗しました。`;
                default:
                    /**
                     * パスワード関連のエラーは発生しない(∵バリデーションしているため)
                     *   InvalidParameterException
                     *   InvalidPasswordException
                     */
                    if (err.code) {
                        return `認証に失敗しました。(${err.code})`;
                    } else {
                        // エラーコードがない場合は表示しない（入力項目が空のときに発生する）
                        return `認証に失敗しました。`;
                    }
            }
        },

        convertSignInErrorMessage(err) {
            switch (err.code) {
                case COGNITO_ERROR_CODE.UserNotFoundException:
                case COGNITO_ERROR_CODE.NotAuthorizedException:
                case COGNITO_ERROR_CODE.InvalidParameterException:
                    return `メールアドレスまたはパスワードが間違っています。`;
                case COGNITO_ERROR_CODE.PasswordResetException:
                    return `パスワードのリセットが必要です。`;
                case COGNITO_ERROR_CODE.LimitExceededException:
                    return `試行回数の上限に達しました。時間をおいてから再度お試しください。`;
                default:
                    if (err.code) {
                        return `認証に失敗しました。(${err.code})`;
                    } else {
                        // エラーコードがない場合は表示しない（入力項目が空のときに発生する）
                        return `認証に失敗しました。`;
                    }
            }
        },

        convertForgotPasswordErrorMessage(err) {
            switch (err.code) {
                case COGNITO_ERROR_CODE.UserNotFoundException:
                    return `メールアドレスが間違っています。`
                case COGNITO_ERROR_CODE.CodeMismatchException:
                    return `検証コードが一致しませんでした。`
                case COGNITO_ERROR_CODE.ExpiredCodeException:
                    return `期限切れの検証コードです。`
                case COGNITO_ERROR_CODE.LimitExceededException:
                    return `試行回数の上限に達しました。時間をおいてから再度お試しください。`;
                case COGNITO_ERROR_CODE.CodeDeliveryFailureException:
                    return `検証コードの送信に失敗しました。`;
                default:
                    /**
                     * パスワード関連のエラーは発生しない(∵バリデーションしているため)
                     *   InvalidParameterException
                     *   InvalidPasswordException
                     */
                    if (err.code) {
                        return `認証に失敗しました。(${err.code})`;
                    } else {
                        // エラーコードがない場合は表示しない（入力項目が空のときに発生する）
                        return `認証に失敗しました。`;
                    }
            }
        },
    },
};
